/**
 * PageChromeEditor - edits the running header & footer text and the page-number
 * toggle for the body page section. These were never editable in the old
 * workbench (only logos were). Operates through the pure helpers in
 * `lib/sowPageChrome`, which preserve any logo tables already present.
 */

import { SegmentedControl, TextField } from '@protoss/ui';
import type { PageChrome } from '../../lib/sowPageChrome';

export interface PageChromeEditorProps {
  pageChrome: PageChrome;
  canEdit: boolean;
  onChange: (patch: Partial<PageChrome>) => void;
}

export function PageChromeEditor({ pageChrome, canEdit, onChange }: PageChromeEditorProps) {
  if (!canEdit) {
    return (
      <div className="sow-studio-inspector__group">
        <Row label="Header" value={pageChrome.headerText || '-'} />
        <Row label="Footer" value={pageChrome.footerText || '-'} />
        <Row label="Page numbers" value={pageChrome.showPageNumbers ? 'On' : 'Off'} />
      </div>
    );
  }
  return (
    <div className="sow-studio-inspector__group">
      <TextField
        label="Header text"
        value={pageChrome.headerText}
        placeholder="Running header (appears on every page)"
        onChange={(e) => onChange({ headerText: e.target.value })}
      />
      <TextField
        label="Footer text"
        value={pageChrome.footerText}
        placeholder="Running footer (appears on every page)"
        onChange={(e) => onChange({ footerText: e.target.value })}
      />
      <div className="sow-studio-inspector__field">
        <span className="sow-studio-inspector__group-label">Page numbers</span>
        <SegmentedControl<'on' | 'off'>
          ariaLabel="Page numbers"
          value={pageChrome.showPageNumbers ? 'on' : 'off'}
          onChange={(v) => onChange({ showPageNumbers: v === 'on' })}
          options={[
            { value: 'on', label: 'On' },
            { value: 'off', label: 'Off' },
          ]}
        />
      </div>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="sow-studio-inspector__row-kv">
      <span className="sow-studio-inspector__group-label">{label}</span>
      <span className="sow-studio-inspector__value">{value}</span>
    </div>
  );
}
